import { useEffect, useState } from 'react';
import { useRoutes } from '../hooks/useRoutes';
import { useTranslation } from 'react-i18next';
import CookieKeys from '../constants/CookieKeys';
import Cookies from '../utils/Cookies';
import { buildGroupProps } from '../utils/elementisUtils';

import Alert from '@pelckmans/elementis/components/alert';
import Button from '@pelckmans/elementis/components/button';

const BASE = 'SHARED_COMPONENTS.COOKIE_ALERT';

function CookieAlert() {
  const support = navigator.cookieEnabled;
  const { REACT_APP_ANALYTICS_KEY } = process.env;
  const [interacted, setInteracted] = useState(Boolean(Cookies.get(CookieKeys.cl)));
  const { buildAbsolutePath } = useRoutes();
  const { t } = useTranslation();

  const accepted = Cookies.get(CookieKeys.cl) === 'true';

  useEffect(() => {
    window[`ga-disable-${REACT_APP_ANALYTICS_KEY}`] = !accepted;
  }, [REACT_APP_ANALYTICS_KEY, accepted]);

  const allowCookie = (accepted: boolean) => {
    const now = new Date();
    const expires = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

    Cookies.set(CookieKeys.cl, accepted ? 'true' : 'false', { expires });

    window[`ga-disable-${REACT_APP_ANALYTICS_KEY}`] = !accepted;

    setInteracted(true);
  };

  if (!support) return <Alert prominence="danger">{t(`${BASE}.NO_COOKIES_SUPPORTED`)}</Alert>;

  if (interacted) return null;

  return (
    <Alert
      className="cookie-alert"
      actions={buildGroupProps(
        <>
          <Button prominence="neutral" key="reject-cookies" onClick={() => allowCookie(false)}>
            {t(`${BASE}.ACTIONS.REJECT`)}
          </Button>
          <Button prominence="info" key="accept-cookies" onClick={() => allowCookie(true)}>
            {t(`${BASE}.ACTIONS.ACCEPT`)}
          </Button>
        </>,
      )}
    >
      {t(`${BASE}.MESSAGE`)}{' '}
      <a
        rel="noopener noreferrer"
        className="cookie-alert__more-information"
        target="_blank"
        href={buildAbsolutePath(['PRIVACY_POLICY'])}
      >
        {t(`${BASE}.ACTIONS.LEARN_MORE`)}
      </a>
    </Alert>
  );
}

export default CookieAlert;
